export default __webpack_public_path__ + "static/media/dashboard_en.fc8c9e2f.png";